import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REWARD_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const updateRewardUser = createAsyncThunk("updateRewardUser", async ({ id, values,user_channel }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`${REWARD_BASE_URL}backoffice/user/update/${id}?channel_id=${user_channel}`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RewardUserUpdateSlice = createSlice({
	name: "RewardUserUpdateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetStateRewardUserUpdateSlice: (state) => {
		  // Reset the state to its initial values
		  return  {
				isLoading: false,
				isError: false,
				error: null,
				data: null,
			};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updateRewardUser.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(updateRewardUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(updateRewardUser.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

// Export the reset action to use it in components
export const { resetStateRewardUserUpdateSlice } = RewardUserUpdateSlice.actions;


export default RewardUserUpdateSlice.reducer;
